module.exports = "<route-edit-page class=\"h-100\"></route-edit-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/planningEdit.html
// module id = 1856
// module chunks = 0